import { NgModule } from '@angular/core';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { ChickenTest } from './chicken-test';
import { ChickenTestService } from './chicken-test-service';
import {FlexLayoutModule} from "@angular/flex-layout";
import {CommonModule} from "@angular/common";

@NgModule({
    imports: [AppMaterialModule, FlexLayoutModule, CommonModule],
    exports: [ChickenTest],
    declarations: [ChickenTest],
    providers: [ChickenTestService]
})
export class ChickenTestModule {}
